import { Component } from 'react';
import PropTypes from 'prop-types';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  componentDidCatch(error, info) {
    const { handleError } = this.props;
    this.setState({
      hasError: true,
      error,
    });
    /* eslint-disable no-console */
    console.error(error);
    console.info(info);
    if (process.env.NODE_ENV === 'production') {
      handleError();
    }
  }

  render() {
    const { hasError, error } = this.state;
    const { renderFallbackView, children } = this.props;
    if (hasError) {
      return renderFallbackView(error);
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  handleError: PropTypes.func,
  renderFallbackView: PropTypes.func,
};

ErrorBoundary.defaultProps = {
  renderFallbackView: () => {},
  handleError: () => {},
};
